import { Section as HygraphSectionProps } from '@/lib/types';
import { useHeroContext } from '@/hooks/use-hero-context';

import Section from '@/components/section';

import { EagerImageContext } from '@/context/eager-image-context';
import { getRenderer, getRendererData } from '@/hygraph/renderers';
import sectionTransformer from '@/hygraph/transformers/section.transformer';

type SectionsRendererProps = {
  sections?: Array<HygraphSectionProps>;
};
export default function SectionsRenderer({ sections }: SectionsRendererProps) {
  const { isHero } = useHeroContext();

  if (!sections || sections.length === 0) {
    return <></>;
  }

  return (
    <>
      {sections.map((section, sectionIndex) => {
        const sectionData = sectionTransformer(section);

        if (!sectionData) {
          return <></>;
        }

        const key = sectionData.slug || section.id;
        return (
          <Section key={key} index={sectionIndex} {...sectionData}>
            {section.rows?.map((row, rowIndex) => {
              const isEager = isHero || (rowIndex === 0 && sectionIndex === 0);

              const Renderer = getRenderer(row.__typename);
              if (!Renderer) return <></>;

              return (
                <EagerImageContext.Provider key={row.id} value={isEager}>
                  <Renderer key={row.id} {...getRendererData({ ...row })} />
                </EagerImageContext.Provider>
              );
            })}
          </Section>
        );
      })}
    </>
  );
}
